module.exports = __webpack_public_path__ + "media/images/front/icon_plus_gr-86cdf4b6903195845c7d3dbcbd39efa4.png";